/**
 * Profile-related constants
 * Centralized configuration for profile components and functionality
 */

// Default expanded sections for user profile
export const DEFAULT_EXPANDED_SECTIONS = [
  "about",
  "experience", 
  "education",
  "certifications",
  "opensource",
] as const;

// Skill categories for organization
export const SKILL_CATEGORIES = [
  "Frontend",
  "Backend", 
  "Cloud",
  "DevOps",
  "Tools",
  "Design",
] as const;

// Skill levels with their corresponding colors
export const SKILL_LEVELS = {
  초급: "bg-gray-400",
  중급: "bg-yellow-500", 
  고급: "bg-blue-500",
  전문가: "bg-green-500",
} as const;

// Open source contribution roles
export const OPENSOURCE_ROLES = [
  "Contributor",
  "Maintainer", 
  "Owner",
] as const;

// File size formatting
export const FILE_SIZE_UNITS = {
  BYTES: 1,
  KB: 1024,
  MB: 1024 * 1024,
  GB: 1024 * 1024 * 1024,
} as const;

// Date formatting options
export const DATE_FORMAT_OPTIONS = {
  year: "numeric" as const,
  month: "long" as const,
} as const;

// Modal configurations
export const MODAL_CONFIGS = {
  RESUME: {
    maxWidth: "max-w-2xl",
    maxHeight: "max-h-[80vh]",
  },
  PORTFOLIO_FILES: {
    maxWidth: "max-w-4xl", 
    maxHeight: "max-h-[80vh]",
  },
} as const;

// Profile section order
export const PROFILE_SECTION_ORDER = [
  "about",
  "experience",
  "education", 
  "portfolio",
  "opensource",
  "certifications",
  "recommendations",
  "skills",
] as const;
